var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9541 3.37793H14.5166V17.1279H7.9541V3.37793Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0166 3.37793C1.84212 3.37793 0.735352 4.91699 0.735352 6.81543V13.6904C0.735352 15.5889 1.84212 17.1279 4.0166 17.1279H7.9541V3.37793H4.0166Z",
    fill: "#1B75BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7979 3.37793H14.5166V17.1279H18.4541C20.6286 17.1279 21.7354 15.5889 21.7354 13.6904V6.81543C21.7354 4.91668 21.7216 3.37793 17.7979 3.37793Z",
    fill: "#EC1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white",
    transform: "translate(0.735352 0.25293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.5005695836690257297504d8f9ec1cf1.svg";
export { ForwardRef as ReactComponent };